import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { UpdateEmailInfo } from '@client/utils/shared-constants';
import { from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class EmailService {
	constructor(private afAuth: AngularFireAuth, private db: AngularFireDatabase) {}

	updateEmail({ email, currentPassword }: UpdateEmailInfo): Observable<any> {
		return this.afAuth.user.pipe(
			take(1),
			switchMap(u =>
				from(
					this.afAuth
						.signInWithEmailAndPassword(u.email, currentPassword)
						.then(_r => {
							return u.updateEmail(email);
						})
						.then(_x => {
							return u.sendEmailVerification();
						})
				)
			)
		);
	}
}
